import React, { useEffect, useRef, useState, useCallback } from "react";
import gameAssets from "@themed-assets";
import { motion } from "motion/react";
import styles from './PotAmounts.module.css';

const ChipComponent = ({
    index,
    shouldAnimate,
    winner,
    winningPotData,
    chipIndex,
}) => {
    let allChipImages = [gameAssets.brandChip, gameAssets.brandChip, gameAssets.brandChip, gameAssets.brandChip, gameAssets.brandChip];
    let chipRef = useRef(null);
    const [chipLeftEndingCoordinate, setChipEndingLeftCoordinate] = useState(0);
    const [chipTopEndingCoordinate, setChipEndingTopCoordinate] = useState(0);
    const chipsLength = 10;

    const returnHorizontalPotTranslation = useCallback((player) => {
        if (chipRef?.current) {
            let chipLeftValue = chipRef?.current?.getBoundingClientRect().left;
            let playerCoordinateLeft =
                winningPotData?.playerCoordinates[player]?.left;
            return playerCoordinateLeft - chipLeftValue;
        }
        return 0;
    }, [winningPotData]);

    const returnVerticalPotTranslation = useCallback((player) => {
        if (chipRef?.current) {
            let chipTopValue = chipRef?.current?.getBoundingClientRect().top;
            let playerCoordinateTop = winningPotData?.playerCoordinates[player]?.top;
            return playerCoordinateTop - chipTopValue + 75;
        }
        return 0;
    }, [winningPotData]);

    useEffect(() => {
        if (shouldAnimate) {
            setChipEndingLeftCoordinate(returnHorizontalPotTranslation(winner));
            setChipEndingTopCoordinate(returnVerticalPotTranslation(winner));
        } else {
            setChipEndingLeftCoordinate(0);
            setChipEndingTopCoordinate(0);
        }
    }, [shouldAnimate, returnHorizontalPotTranslation, returnVerticalPotTranslation, winner]);

    const chipAnimationSequence = [
        {
            left: chipLeftEndingCoordinate,
            top: chipTopEndingCoordinate,
            position: "absolute",
            transition: {
                delay: 0.1 * (chipsLength - chipIndex),
            },
        },
        {
            opacity: 0,
            transition: {
                delay: 0.15 * (chipsLength - chipIndex),
            },
        },
    ];

    return (
        <motion.img className={styles.chipComponent}
            ref={chipRef}
            src={allChipImages[index]}
            initial={{
                opacity: 1,
                scale: 1,
                y: -0.75 * chipIndex,
            }}
            animate={shouldAnimate ? chipAnimationSequence : null}
        />
    );
};

export default ChipComponent;
